import * as React from 'react';
import { uieLightTheme } from './uieThemes';
export const UIEThemeContext = React.createContext(uieLightTheme);
//# sourceMappingURL=UIEThemeContext.js.map